import React from 'react';
import s from './index.module.scss';

import { PaymentOffer } from './paymentOffer';
import { MainScreenSelector } from './mainScreenSelector';
import { MainScreenDogTranslator } from '../../components/everydoggyV2/mainScreenDogTranslator';
import { Timer } from '../../components/everydoggyV2/timer';
import { Reviews } from '../../components/everydoggyV2/reviews/reviews';
import { BarChartV4 } from '../../components/everydoggyV2/barChartV4/barChart';
import { Benefits } from '../../components/everydoggyV5/benefits/benefits';
import { VetSupportBlock } from '../../components/everydoggyV5/vetSupportBlock/vetSupportBlock';
import { NutritionSupportBlock } from '../../components/everydoggyV5/nutritionSupportBlock';
import { PolycyBlockV2 } from '../../components/everydoggyV2/polycyBlockV2';
import { GetMyPlanBlock } from '../../components/everydoggyV5/getMyPlanBlock/getMyPlanBlock';
import { SupportBlock } from '../../components/everydoggyV2/supportBlock/supportBlock';
import { ReviewsSlider } from '../../components/everydoggyV5/reviewsSlider/reviewsSlider';
import { Footer } from '../../components/everydoggyV2/footer/footer';
import { DogTranslatorGraphs } from '../../components/everydoggyV5/dogTranslatorGraphs';
import DogBehaviorProgramCard from '../../components/everydoggyV5/dogBehaviorProgramCard';
import { MoneyBack } from '../../components/everydoggyV5/moneyBack/moneyBack';
import { Faq } from '../../components/everydoggyV5/faq/index';

type RegularScreenProps = {
  tariff: string;
  productName: string | null;
  dogTranslator: boolean;
  showVetOnboarding: boolean;
  nutritionOnboarding: boolean;
  puppyOnboarding: boolean;
  puppyBlues: boolean;
  customV52: boolean;
  isLastDogTrainingPaywall: boolean;
  showMoneyBack: boolean;
};

/** The default (non-discount) paywall screen. */
export const RegularScreen = ({
  tariff,
  productName,
  dogTranslator,
  showVetOnboarding,
  nutritionOnboarding,
  puppyOnboarding,
  puppyBlues,
  customV52,
  isLastDogTrainingPaywall,
  showMoneyBack,
}: RegularScreenProps) => {
  const flushTopPadding =
    dogTranslator ||
    showVetOnboarding ||
    nutritionOnboarding ||
    puppyOnboarding ||
    puppyBlues ||
    customV52 ||
    isLastDogTrainingPaywall;

  return (
    <div style={{ paddingTop: flushTopPadding ? 0 : '20px' }} className={s.firstScreenWrapper}>
      {dogTranslator ? (
        <>
          <div key="paywall-timer" className={s.timerWrapperTop}>
            <Timer tariff={tariff} />
          </div>
          <MainScreenDogTranslator key="paywall-main-screen" />
        </>
      ) : (
        <MainScreenSelector
          vetOnboarding={showVetOnboarding}
          nutritionOnboarding={nutritionOnboarding}
          puppyOnboarding={puppyOnboarding}
          puppyBlues={puppyBlues}
          isLastDogTrainingPaywall={isLastDogTrainingPaywall}
          customV52={customV52}
          tariff={tariff}
        />
      )}
      {!dogTranslator && (
        <div className={s.reviewsWrapper}>
          <Reviews />
        </div>
      )}
      {dogTranslator ? (
        <DogTranslatorGraphs />
      ) : showVetOnboarding ? (
        <div className={s.vetSupportWrapper}>
          <VetSupportBlock />
        </div>
      ) : nutritionOnboarding ? (
        <div className={s.nutritionSupportWrapper}>
          <NutritionSupportBlock />
        </div>
      ) : (
        <div style={customV52 ? { marginTop: '35px' } : undefined} className={s.barChartWrapper}>
          {isLastDogTrainingPaywall ? <DogBehaviorProgramCard /> : <BarChartV4 />}
        </div>
      )}
      <div className={s.benefitsWrapper}>
        <Benefits />
      </div>
      <div className={s.offerWrapper}>
        <PaymentOffer currentProduct={productName} discount={false} tariff={tariff} />
      </div>
      <div className={s.polycyWrapper}>
        <PolycyBlockV2 />
      </div>
      <div className={s.getMyplanWrapper}>
        <GetMyPlanBlock tariff={tariff} />
      </div>

      {showMoneyBack && !showVetOnboarding ? <MoneyBack /> : null}

      {showMoneyBack && !showVetOnboarding ? <Faq /> : null}

      <div className={s.supportBlockWrapper}>
        <SupportBlock />
      </div>
      <div className={s.ReviewsSliderWrapper}>
        <ReviewsSlider />
      </div>

      <Footer />
    </div>
  );
};
